import fetch from "@/fetch";
// 活动列表查询
export const activityListGet = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/getactivitylist",
    data: params,
    actionTypeCode: "9",
    actionTypeDesc: "活动列表获取",
  });
};
// 活动详情查询
export const activityInfoGet = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/activitydetail",
    data: params,
    loading: true,
    actionTypeCode: "10",
    actionTypeDesc: "活动详情获取",
  });
};
// 活动预约
export const activityAppointment = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/activity/appointment",
    data: params,
    loading: true,
    actionTypeCode: "11",
    actionTypeDesc: "活动预约",
  });
};
// 活动收藏
export const activityFavorites = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/activity/favorites",
    data: params,
    loading: true,
    actionTypeCode: "12",
    actionTypeDesc: "活动收藏",
  });
};
// 活动扫码签到
export const activitySign = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/activitysignin",
    data: params,
    loading: true,
    actionTypeCode: "51",
    actionTypeDesc: "活动扫码签到",
  });
};
// 活动签到状态获取
export const activitySignStatus = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/userpoint/getactivitysigninstatus",
    data: params,
    loading: true,
    actionTypeCode: "52",
    actionTypeDesc: "活动签到状态获取",
  });
};
